import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accessToken: localStorage.getItem("access_token") || null,
  role_id: localStorage.getItem("role_id") || null,
  accessData: JSON.parse(localStorage.getItem("accessData")) || null, // Store accessData
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      console.log("Redux loginSuccess Action:", action.payload);
      state.accessToken = action.payload.accessToken;
      state.role_id = action.payload.role_id;
      state.accessData = action.payload.accessData; // Store accessData in Redux
    },
    logout: (state) => {
      state.accessToken = null;
      state.role_id = null;
      state.accessData = null;
      localStorage.removeItem("access_token");
      localStorage.removeItem("role_id");
      localStorage.removeItem("accessData");
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
